// extracted by mini-css-extract-plugin
module.exports = {"container":"ToggleTheme_container__3Ffdk","sun":"ToggleTheme_sun__1K2pK","moon":"ToggleTheme_moon__2R_U9","toggle":"ToggleTheme_toggle__32Mn2"};